module.exports = __webpack_public_path__ + "media/images/ohap_lms_integration_on-95f59925f56878673bd418f474bec8d0.png";